import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {config} from '../config/config'; // Adjust this path as needed
import successImage from '../assets/logoIcon.svg'; // Replace with your own image

const SubscriptionHandler = () => {
  const [statusMessage, setStatusMessage] = useState('Processing your subscription...');
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const handleRedirect = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const subscriptionId = urlParams.get('subscription_id');

      if (!subscriptionId) {
        console.error('Missing subscription_id in URL.');
        setStatusMessage('Invalid subscription information.');
        setTimeout(() => window.location.replace('/dashboard'), 3000);
        return;
      }

      try {
        const response = await fetch(
          `${config.baseURL}/save_dodo_subscription.php`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ subscription_id: subscriptionId }),
          }
        );

        const result = await response.json();

        if (response.ok && result.success) {
          // SAVE plan_id to sessionStorage under the key "ActiveSubscription"
          sessionStorage.setItem('ActiveSubscription', result.plan_id);

          // Notify user
          toast.success('Subscription is active!');

          setStatusMessage('Subscription successful!');

        } else if (response.ok && !result.success) {
          // Subscription exists but not yet active
          setStatusMessage(result.message || 'Subscription pending.');
          toast.info(result.message || 'Your subscription is processing.');
        } else {
          // HTTP 4xx/5xx or unexpected
          console.error('Subscription check failed:', result);
          setStatusMessage('Subscription check failed.');
          toast.error('Failed to verify subscription. Please try again.');
        }
      } catch (err) {
        console.error('Error checking subscription status:', err);
        setStatusMessage('An error occurred while verifying subscription.');
        toast.error('An error occurred. Please try again.');
      } finally {
        setIsLoading(false);
        //Clear query params and redirect after a short delay
        const cleanUrl = window.location.href.split('?')[0];
    window.history.replaceState({}, '', cleanUrl);
        setTimeout(() => window.location.replace('/premium'), 3000);
      }
    };

    handleRedirect();
  }, []);


  return (
    <div className="_subscription-handler-container">
      <img
        src={successImage}
        alt="Subscription"
        className="_subscription-handler-image"
      />
      <div className="_subscription-handler-message">{statusMessage}</div>
      {isLoading && (
        <div className="_subscription-handler-loader">
          <div className="_subscription-handler-spinner"></div>
        </div>
      )}

      <style jsx="true">{`
        ._subscription-handler-container {
          background-color: #22222a;
          color: #ffffff;
          height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 20px;
        }

        ._subscription-handler-image {
          width: 120px;
          margin-bottom: 20px;
        }

        ._subscription-handler-message {
          font-size: 18px;
          margin-top: 10px;
        }

        ._subscription-handler-loader {
          margin-top: 20px;
        }

        ._subscription-handler-spinner {
          border: 4px solid rgba(255, 255, 255, 0.2);
          border-top: 4px solid #ffffff;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          animation: _subscription-handler-spin 1s linear infinite;
        }

        @keyframes _subscription-handler-spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default SubscriptionHandler;
